import React, {useEffect, useState } from "react";
import { getAllOutsourcedStaffs } from "../../utils/helper";
import Loader from "../../utils/Loader";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { useHistory } from "react-router-dom";

export default function OutsourcingEmployees() {
    const [loading, setLoading] = useState(false);
    const [staffs, setAllOutsourcedStaffs] = useState(null);
    const history = useHistory();

    useEffect(() => {
        setLoading(true);
        getAllOutsourcedStaffs()
            .then((res) => { 
                setAllOutsourcedStaffs(res.data.data);  
                setTimeout(() => {
                    setLoading(false)
                }, 3500);
            })
            .catch((err) => {
                console.log(err?.response)
                setTimeout(() => {
                    setLoading(false)
                }, 3500);
            });
    }, []);

    const navigateById = (path, id) => {
        history.push(`${path}/${id}`);
    };

    return (
        <>
            <div className="spur-card-menu"><Link to="/outsourcing/employees/add" className="pull-right btn topbtn btn-primary">ADD NEW EMPLOYEES</Link></div>
            
            <h1 className="dash-title">Outsourcing</h1>

            <div className="row dash-row">
                
                <div className="col-md-12 col-sm-12 col-12">
                    <div className="card spur-card" style={{marginTop: 5}}>
                        <div className="card-header">
                            <div className="spur-card-title">Outsourced Employees</div>
                        </div>
                        <div className="card-body">
                            <div className="my_profile">
                                {(!loading && staffs && staffs) ? 
                                    <div className="table-responsive">
                                        {(staffs && staffs.length > 0) ?
                                        <table className="table text-left text-caps table-bordered" id="myTable">
                                            <thead><tr><th>SN</th><th>Name</th><th>Email</th><th>Phone</th><th>Organization</th><th>Staff ID</th><th>Job Title</th>
                                            <th>Status</th><th>View</th></tr></thead>
                                            <tbody>
                                                {staffs && staffs.map((row, index) => 
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{row?.first_name && row?.first_name} {row?.last_name && row?.last_name}</td>
                                                        <td>{row?.email && row?.email}</td>
                                                        <td>{row?.phone && row?.phone}</td>
                                                        <td>{row?.organization?.name && row?.organization?.name}</td>
                                                        <td>{row?.staff_id && row?.staff_id}</td>
                                                        <td>{row?.job_role?.name && row?.job_role?.name}</td> 
                                                        <td>{row?.status === "new" ? 
                                                        <span className="badge badge-danger">{row.status}</span> : 
                                                        <span className="badge badge-warning">{row.status}</span>}</td>
                                                        <td>
                                                            <button 
                                                                onClick={() => navigateById("/outsourcing/staff", row._id)} 
                                                                className='btn btn-preview'
                                                                disabled
                                                            >
                                                                    <i className="fa fa-eye"></i> View
                                                            </button>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table> : 
                                        <div className="alert alert-danger myerror d-block">No record found.</div> }
                                    </div>
                                : <Loader /> }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
